import React from "react";
import { Badge, Button, Card } from "react-bootstrap";
import dayjs from "dayjs";

const KIND_LABELS = {
  STUDENTS: "+50 estudiantes activos",
  TEACHERS: "+5 docentes",
  HEADQUARTERS: "+1 sede",
};

const STATUS = {
  PENDING: { label: "Pendiente de pago", variant: "warning" },
  PAID: { label: "Activo", variant: "success" },
  CANCELED: { label: "Cancelado", variant: "secondary" },
};

/**
 * CapacityBlockCard — muestra un bloque de capacidad.
 *
 * Props:
 *   block    { id, kind, description, monthly_price_cop, status, expires_at }
 *   onDelete function(id) — si se pasa, muestra botón eliminar
 */
function CapacityBlockCard({ block, onDelete }) {
  const { id, kind, description, monthly_price_cop, status, expires_at } = block;
  const st = STATUS[status] ?? null;

  return (
    <Card className="mb-2">
      <Card.Body className="d-flex align-items-center gap-3 py-2 px-3 flex-wrap">
        <div className="flex-grow-1">
          <span className="fw-medium">{KIND_LABELS[kind] ?? kind}</span>
          {description && (
            <span className="text-muted ms-2 small">{description}</span>
          )}
        </div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          {st && <Badge bg={st.variant}>{st.label}</Badge>}
          <Badge bg="secondary">
            ${Number(monthly_price_cop || 0).toLocaleString("es-CO")}/mes
          </Badge>
          {expires_at && (
            <span className="small text-muted">
              vence {dayjs(expires_at).format("DD/MM/YYYY")}
            </span>
          )}
          {onDelete && (
            <Button
              size="sm"
              variant="outline-danger"
              onClick={() => onDelete(id)}
              aria-label={`Eliminar bloque ${KIND_LABELS[kind] ?? kind}`}
            >
              Eliminar
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export { CapacityBlockCard };
